<script>
  import Close from "@/components/partials/icons/Close.vue";
  import Info from "../icons/Info.vue";

  export default {
    components: {
      Info,
      Close,
    },
    props: {
      title: {
        type: String,
        default: "",
      },
      closeBtnStatus: {
        type: String,
        default: "enabled",
      },
    },
    data() {
      return {};
    },

    methods: {
      cancel() {
        this.$emit("cancel");
      },
    },
  };
</script>

<template>
  <div class="d-flex justify-content-between align-items-center p-24 radius-8">
    <div class="d-flex align-items-center">
      <Info class="m-r-6" color="var(--neutral-900)" />
      <slot name="header-title">
        <span class="heading-5-bold">{{ $t(`titles.${title}`) }}</span>
      </slot>
    </div>
    <Close
      color="var(--neutral-300)"
      :class="closeBtnStatus === 'disabled' ? 'cursor-no-drop opacity-04' : 'cursor-pointer'"
      @click.native="closeBtnStatus === 'enabled' && cancel()"
    />
  </div>
</template>

<style scoped lang='sass'>
.heading-5-bold
  @media (max-width: 576px)
    font-size: 18px

</style>
